<script>
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  props: {
    href: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    openLink() {
      window.open(this.href, '_blank');
    },
  },
};
</script>

<template>
  <PhxsgButton variant="fade" :no-caps="true" :label="label" @click="openLink" />
</template>
